// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"d4939d28","453":"c2b2afdb","796":"4ecf5ddc"}[chunkId] + ".chunk.js";
};